module.exports = __webpack_public_path__ + "resource/img/image023.28660dc1.png";